import { Component, Input } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { SharedService } from 'app/shared/shared.service';

@Component({
  selector: 'ashcorp-button',
  templateUrl: './ashcorp-button.component.html',
  animations: fuseAnimations
})

export class Ashcorp_Button_Component {
  @Input() component: any;
  @Input() color: string;
  @Input() click: any;

  public helper: SharedService;

  constructor(private _shared_service: SharedService) {
    this.helper = this._shared_service;
  }

  public event(action: string) {
    this.component[action]();
  }
}
